export const SWIPER_SLIDE_CLASS = 'swiper-slide'
